/**
 * Slider images
 * **************************************
 */

// $('.product-single__media-group').slick({
//     adaptiveHeight: true,
//     dots: true,
// }); 

/*============================================================================
  Product
==============================================================================*/

var product = {
    init: function () {
        var $productSection = $('.product_slider').parents('.product_section');
        var thumbnailPosition = $productSection.data('thumbnail');
        var slideshowAnimation = $productSection.data('slideshow-animation');
        var slideshowSpeed = $productSection.data('slideshow-speed');
        var $notify_form = $('.notify_form .contact-form');
        var next_height = 0;
        var started = false;

        //   this.loadProductRecommendations();
        //   this.updateWidthBasedOnSidebar();

        if (slideshowAnimation == 'zoom') {
            $('.image__container img', $productSection)
                .wrap('<div></div>')
                .parent()
                .zoom({
                    magnify: 1
                });
        }

        $('.product_slider').flexslider({
            startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
            touch: true,
            pauseOnHover: true,
            controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
            directionNav: true,//thumbnailPosition == "no-thumbnails" ? true : false,
            animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
            slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
            slideshowSpeed: slideshowSpeed ? slideshowSpeed * 1000 : 10 * 1000,
            start: function (slider) {
                slider.resize();
                started = true;
            },
            before: function (slider) {
                if (started === true && slideshowAnimation === 'slide') {
                    // for the initial transition
                    next_height = slider.find('.slides > li.flex-active-slide').height();
                    slider.find('ul.slides').css({ 'max-height': next_height });
                    // for the rest
                    next_height = slider.find('.slides > li.flex-active-slide + li').height();
                    slider.find('ul.slides').css({ 'max-height': next_height })
                }
            }
        });

        if (slideshowAnimation === 'slide') {
            $(window).trigger('resize');
        }

        if ($('.slides li:not(.clone)'), $productSection.length == 1) {
            $('.flex-direction-nav', $productSection).hide();
        }

        if(window.innerWidth > 767){
            var sticky = new Sticky('.product_gallery');
        }
        else{
            $('.product_section').removeClass('thumbnail_position--left-thumbnails')
            $('.product_gallery').css('marginTop', '15px')
        }

        // reviews
        $('#shopify-product-reviews').on('click', '.spr-header', function(e){
            if($('.spr-content').css('display') == "none"){
                $('.spr-content').slideDown()
            }
            else{
                if( ! $(e.target).hasClass('spr-summary-actions-newreview')){
                    $('.spr-content').slideUp()
                }
            }
        })

    }
}

/**
 * End Slider images
 * **************************************
 */


product.init();